import { ActionType } from './ActionType';

export type CommonAction = {
  type: ActionType.RESUME_SESSION;
};

export const resumeSession = (): CommonAction => ({
  type: ActionType.RESUME_SESSION,
});

